import React from 'react';
import { Window, Button } from 'react95';
import styles from '../styles/modules/Window.module.css';

import { t, translations } from '../data/translations';

interface WindowInvitationProps {
  onClose: () => void;
  onOpenRSVP?: () => void;
}

const WindowInvitation: React.FC<WindowInvitationProps> = ({ onClose, onOpenRSVP }) => {
  return (
    <Window className={styles.window}>
      <div className={styles.windowHeader}>
        <span>{t('windows.invitation.title')}</span>
        <Button onClick={onClose} size="sm">
          <span>✕</span>
        </Button>
      </div>
      <div className={styles.windowContent}>
        <div className={styles.invitationContainer}>
          <h1 className={styles.invitationTitle}>{t('windows.invitation.mainTitle')}</h1>
          <p className={styles.invitationText}>
            {t('windows.invitation.subtitle')}
          </p>
          
          <div className={styles.partyDetails}>
            <h2>{t('windows.invitation.day1Title')}</h2>
            <p className={styles.timeInfo}>{t('windows.invitation.day1Time')}</p>
            <ul>
              {translations.windows.invitation.day1Program.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <h2>{t('windows.invitation.day2Title')}</h2>
            <p className={styles.timeInfo}>{t('windows.invitation.day2Time')}</p>
            <ul>
              {translations.windows.invitation.day2Program.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <h2>{t('windows.invitation.location')}</h2>
            <p>{t('windows.invitation.locationValue')}</p>
            <Button 
              onClick={() => {
                window.open('https://yandex.by/maps/-/CHsXRF0Z', '_blank', 'noopener,noreferrer');
              }}
              className={styles.mapButton}
            >
              📍 Яндекс карта
            </Button>
            
            <h2>{t('windows.invitation.dressCode')}</h2>
            <p>{t('windows.invitation.dressCodeValue')}</p>

            <h2>{t('windows.invitation.otherWindows')}</h2>
            <ul>
              {translations.windows.invitation.windowsInfo.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <div className={styles.rsvpSection}>
              <p><strong>{t('windows.invitation.rsvpNote')}</strong></p>
              <Button 
                onClick={() => {

                  if (onOpenRSVP) {
                    onOpenRSVP();
                  }
                }}
                className={styles.rsvpButton}
                primary
              >
                {t('windows.invitation.confirmButton')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Window>
  );
};

export default WindowInvitation;
